import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Init from './pages/common/Init';
import Init from './pages/Init';

/*
import Main from './pages/Main';
import Signup from './pages/Signup';
import Login from './pages/Login';

import CorpSignup from './pages/CorpSignup';
import CorpLogin from './pages/CorpLogin';

import Dashboard from './pages/Dashboard';
import RideMap from './pages/RideMap';
import Notice from './pages/Notice';
import Message from './pages/Message';
import Inquiry from './pages/Inquiry';
import Setting from './pages/Setting';
import Billing from './pages/Billing';

import CorpUserLogin from './pages/CorpUserLogin';
import CorpUserRequestPasswordReset from './pages/CorpUserRequestPasswordReset';
import CorpUserPasswordReset from './pages/CorpUserPasswordReset';

import AdminMap from './pages/AdminMap';
import NotFound from './pages/NotFound';
import Template from './pages/Template';

import AdminDashboard from './pages/AdminDashboard';
*/
import Entry from './pages/misc/Entry';
import Template from './pages/misc/Template';

import AdminDashboard from './pages/admin/Dashboard';
import AdminMobileApp from './pages/admin/MobileApp';
import AdminUser from './pages/admin/User';
import AdminUserList from './pages/admin/UserList';
import AdminUserDetail from './pages/admin/UserDetail';
import AdminUserSignupRequestList from './pages/admin/UserSignupRequestList';
import AdminUserSignoutRequestList from './pages/admin/UserSignoutRequestList';

import AdminCorp from './pages/admin/Corp';
import AdminCorpSignupRequestList from './pages/admin/CorpSignupRequestList';
import AdminCorpSignupRequestDetail from './pages/admin/CorpSignupRequestDetail';
import AdminCorpList from './pages/admin/CorpList';
import AdminCorpDetail from './pages/admin/CorpDetail';
import AdminCorpSignoutRequestList from './pages/admin/CorpSignoutRequestList';
import AdminCorpSignoutRequestDetail from './pages/admin/CorpSignoutRequestDetail';

import AdminCorpUser from './pages/admin/CorpUser';
import AdminServiceAndProduct from './pages/admin//ServiceAndProduct';
import AdminBookmark from './pages/admin/Bookmark';
import AdminAnalytics from './pages/admin/Analytics';
import AdminBilling from './pages/admin/Billing';
import AdminNotice from './pages/admin/Notice';
import AdminInquiry from './pages/admin/Inquiry';
import AdminMessage from './pages/admin/Message';
import AdminSetting from './pages/admin/Setting';
import AdminMapTest from './pages/admin/MapTest';
import AdminLogin from './pages/admin/Login';

import AdminNoticeCreate from './pages/admin/NoticeCreate';
import AdminNoticeList from './pages/admin/NoticeList';
import AdminNoticeDetail from './pages/admin/NoticeDetail';

import AdminInquiryList from './pages/admin/InquiryList';
import AdminInquiryDetail from './pages/admin/InquiryDetail';

import AdminServicesHome from './pages/admin/ServicesHome';



import AdminTripPostList from './pages/admin/TripPostList';

import CorpLogin from './pages/corp/Login';

import Login from './pages/common/Login';
//import NotFound from './pages/common/NotFound';
import NotFound from './pages/NotFound';

import KrMain from './pages/kr/Main';
import KrCorpSignup from './pages/kr/corp/Signup';
import KrCorpLogin from './pages/kr/corp/Login';
import KrCorpPasswordResetRequest from './pages/kr/corp/PasswordResetRequest';
import KrCorpPasswordReset from './pages/kr/corp/PasswordReset';
import KrCorpSignupKR from './pages/kr/corp/SignupKR';
import KrCorpSignupETC from './pages/kr/corp/SignupETC';




export default () => {
    return (
        <Router basename='/'>
            <Routes>
                {/*<Route exact path="/" component={<Template />} />*/}

                <Route exact path="/" element={<Init />} />
                <Route exact path="/template" element={<Template />} />
                <Route exact path="/kr" element={<KrMain />} />
                <Route exact path="/kr/corp/signup" element={<KrCorpSignup />} />
                <Route exact path="/kr/corp/signup/KR" element={<KrCorpSignupKR />} />
                <Route exact path="/kr/corp/signup/US" element={<KrCorpSignupKR />} />
                <Route exact path="/kr/corp/signup/JP" element={<KrCorpSignupKR />} />
                <Route exact path="/kr/corp/signup/:code" element={<KrCorpSignupETC />} />
                <Route exact path="/kr/corp/login" element={<KrCorpLogin />} />
                <Route exact path="/kr/corp/password/reset/request" element={<KrCorpPasswordResetRequest />} />
                <Route exact path="/kr/corp/password/reset/:code" element={<KrCorpPasswordReset />} />

                {/*<Route exact path="/:lang" element={<Template />} />
                <Route exact path="/:lang/admin/login" element={<AdminLogin />} />
                <Route exact path="/:lang/admin/dashboard" element={<AdminDashboard key={Date.now()} />} />
                <Route exact path="/:lang/admin/mobile_app" element={<AdminMobileApp key={Date.now()} />} />
                <Route exact path="/:lang/admin/mobile_app/list/:page" element={<AdminMobileApp key={Date.now()} />} />

                <Route exact path="/:lang/admin/user" element={<AdminUser />} />
                <Route exact path="/:lang/admin/user/signup/request/list/:page" element={<AdminUserSignupRequestList />} />
                <Route exact path="/:lang/admin/user/list/:page" element={<AdminUserList />} />
                <Route exact path="/:lang/admin/user/detail/:id" element={<AdminUserDetail />} />
                <Route exact path="/:lang/admin/user/signout/request/list/:page" element={<AdminUserSignoutRequestList />} />
                
                <Route exact path="/:lang/admin/corp" element={<AdminCorp />} />
                <Route exact path="/:lang/admin/corp/signup/request/list/:page" element={<AdminCorpSignupRequestList />} />
                <Route exact path="/:lang/admin/corp/signup/request/detail/:id" element={<AdminCorpSignupRequestDetail />} />
                <Route exact path="/:lang/admin/corp/signout/request/list/:page" element={<AdminCorpSignoutRequestList />} />
                <Route exact path="/:lang/admin/corp/signout/request/detail/:id" element={<AdminCorpSignoutRequestDetail />} />
                <Route exact path="/:lang/admin/corp/list/:page" element={<AdminCorpList />} />
                <Route exact path="/:lang/admin/corp/detail/:id" element={<AdminCorpDetail />} />

                <Route exact path="/:lang/admin/corp_user" element={<AdminCorpUser />} />
                <Route exact path="/:lang/admin/service_and_product" element={<AdminServiceAndProduct />} />
                <Route exact path="/:lang/admin/bookmark" element={<AdminBookmark />} />
                <Route exact path="/:lang/admin/analytics" element={<AdminAnalytics />} />
                <Route exact path="/:lang/admin/billing" element={<AdminBilling />} />

                <Route exact path="/:lang/admin/notice/new" element={<AdminNoticeCreate />} />
                <Route exact path="/:lang/admin/notice/list/:page" element={<AdminNoticeList />} />
                <Route exact path="/:lang/admin/notice/detail/:id" element={<AdminNoticeDetail />} />

                <Route exact path="/:lang/admin/inquiry/list/:page" element={<AdminInquiryList />} />
                <Route exact path="/:lang/admin/inquiry/detail/:id" element={<AdminInquiryDetail />} />

                <Route exact path="/:lang/admin/inquiry" element={<AdminInquiry />} />
                <Route exact path="/:lang/admin/message" element={<AdminMessage />} />
                <Route exact path="/:lang/admin/setting" element={<AdminSetting />} />
                <Route exact path="/:lang/admin/template" element={<Template />} />
                <Route exact path="/:lang/admin/map_test" element={<AdminMapTest />} />



                <Route exact path="/:lang/admin/services" element={<AdminServicesHome />} />*/}

                {/* Angel Trip */}
                <Route exact path="/:lang/admin/trip/post/list/:page" element={<AdminTripPostList />} />








                {/*}
                <Route exact path="/template" element={<Template />} />


                <Route exact path="/:lang" element={<Main />} />
                <Route exact path="/:lang/signup" element={<Signup />} />
                <Route exact path="/:lang/login" element={<Login />} />
                <Route exact path="/:lang/corp/signup" element={<CorpSignup />} />
                <Route exact path="/:lang/corp/login" element={<CorpLogin />} />
                <Route exact path="/:lang/corp/user/login" element={<CorpUserLogin />} />
                <Route exact path="/:lang/corp/user/password/reset/request" element={<CorpUserRequestPasswordReset />} />
                <Route exact path="/:lang/corp/user/password/reset/:code" element={<CorpUserPasswordReset />} />
                <Route exact path="/:lang/corp/console/dashboard" element={<Dashboard />} />
                <Route exact path="/:lang/corp/console/notice" element={<Notice />} />
                <Route exact path="/:lang/corp/console/inquiry" element={<Inquiry />} />
                <Route exact path="/:lang/corp/console/message" element={<Message />} />
                <Route exact path="/:lang/corp/console/billing" element={<Billing />} />
                <Route exact path="/:lang/corp/console/setting" element={<Setting />} />




                <Route exact path="/:lang/admin/dashboard" element={<AdminDashboard />} />

          



                <Route exact path="/admin/map" element={<AdminMap />} />
                */}

                <Route exact path="/:lang/login" element={<Login />} />
                <Route exact path="/:lang/corp/login" element={<CorpLogin />} />

                <Route exact path="/*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}